import {createActions} from 'redux-actions';
import {database} from '../../firebase/index'

export const actions = createActions({
    messages: {
        select(theme, text, next, route, id) {
            let payload = {};
            const isContact = (next === 'contact');
            if (isContact) {
                route.push({
                    question: next,
                    theme: theme
                })
                payload = {
                    question: next,
                    route: route,
                    theme: theme
                };
            } else {
                route.push({
                    answer: next,
                    question: next,
                    theme: theme
                });
                payload = {
                    answer: next,
                    question: next,
                    route: route,
                    theme: theme
                };
            }
            console.log(payload);
            database.ref('answer').child(id).update(payload);
            payload['text'] = text;
            payload['isContact'] = isContact;
            return payload
        }
    },
});
